export const DETAIL_PANEL_ITEM_ID_KEY = '_id';
